import PropTypes from 'prop-types';

export const cellRendererFrameworkPropTypes = {
  data: PropTypes.object.isRequired,
  colDef: PropTypes.object.isRequired
};
